import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';

// App stránky sa načítavajú lazy — pri LANDING_ONLY builde (Cloudflare Pages
// marketingový web) sa do hlavného bundlu vôbec nedostanú.
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Admin = lazy(() => import('./pages/Admin'));
const SuperAdmin = lazy(() => import('./pages/SuperAdmin'));
const TenantEdit = lazy(() => import('./pages/TenantEdit'));

// Build-time prepínač: marketingový web (len landing, žiadny router/app kód)
const LANDING_ONLY = process.env.REACT_APP_LANDING_ONLY === 'true';

function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

function App() {
  // Marketingový build (schvalovaniefaktur.sk) — iba landing, bez routera.
  if (LANDING_ONLY) {
    return <Landing />;
  }

  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!isTokenValid(token)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  const validToken = isTokenValid(token);
  const isAdmin = user.role === 'admin' || user.isSuperAdmin;
  const isSuperAdmin = user.isSuperAdmin;

  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route path="/" element={validToken ? <Navigate to="/dashboard" /> : <Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={validToken ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/admin" element={validToken && isAdmin ? <Admin /> : <Navigate to="/login" />} />
          <Route path="/superadmin" element={validToken && isSuperAdmin ? <SuperAdmin /> : <Navigate to="/login" />} />
          <Route path="/superadmin/tenant/:slug" element={validToken && isSuperAdmin ? <TenantEdit /> : <Navigate to="/login" />} />
          <Route path="*" element={<Navigate to={validToken ? "/dashboard" : "/"} />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
